import clsx from "clsx";
import type { ChildrenProps, ClassNameProps } from "../types";
import { DataGridCell } from "./data-grid-cell";
import { DataGridDivider } from "./data-grid-divider";
import { DataGridLabel } from "./data-grid-label";
import { DataGridRow } from "./data-grid-row";
import { DataGridValue } from "./data-grid-value";

/** Props Interface */
interface DataGridProps extends ChildrenProps, ClassNameProps {
	onClick?: () => void;
	align?: "left" | "right";
	variant?: "default" | "border";
}

export function DataGrid({
	children,
	className,
	onClick,
	align = "left",
	variant = "default",
}: DataGridProps) {
	return (
		<div
			className={clsx(
				"data-grid",
				"shrink-0",
				align === "left" ? "data-grid-left text-left" : "data-grid-right text-right",
				variant === "border" && "data-grid-border",
				className,
			)}
			onClick={onClick}
		>
			{children}
		</div>
	);
}

DataGrid.Label = DataGridLabel;

DataGrid.Value = DataGridValue;

DataGrid.Cell = DataGridCell;

DataGrid.Row = DataGridRow;

DataGrid.Divider = DataGridDivider;
